import { jsx as _jsx } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { ItemConditionType, } from '@hellodarwin/core/lib/features/entities/gin-step-entities';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import { formatDollarValue } from '../../../../../shared/utils';
import { useGinSteps } from '../../../gin-steps-provider';
import { useGinStepUtils } from '../../../utils';
import { GinStepPropertyConditionsContainer } from './styles';
const GinStepPropertyConditions = ({ conditions, isDateProperty, isNumberProperty, selectedLocale, accentColor, propertyLabel, }) => {
    var _a, _b, _c, _d;
    const { formState } = useGinSteps();
    const { getConditionTypeLabel } = useGinStepUtils();
    const { t } = useTranslations();
    if (!conditions || conditions.length === 0)
        return null;
    const isBetweenCondition = conditions.length > 1 &&
        conditions.some((c) => c.condition_type === ItemConditionType.Greater) &&
        conditions.some((c) => c.condition_type === ItemConditionType.Lower);
    const [firstCondition, secondCondition] = conditions;
    const rawFirstValue = (_b = (_a = firstCondition === null || firstCondition === void 0 ? void 0 : firstCondition.trigger_values) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.trigger_value;
    const rawSecondValue = (_d = (_c = secondCondition === null || secondCondition === void 0 ? void 0 : secondCondition.trigger_values) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.trigger_value;
    let firstValue = rawFirstValue;
    let secondValue = rawSecondValue;
    if (isBetweenCondition && isNumberProperty) {
        const n1 = Number(rawFirstValue);
        const n2 = Number(rawSecondValue);
        if (!isNaN(n1) && !isNaN(n2) && n1 > n2) {
            firstValue = rawSecondValue;
            secondValue = rawFirstValue;
        }
    }
    if (isBetweenCondition && (!firstValue || !secondValue))
        return null;
    if (!isBetweenCondition && !firstValue)
        return null;
    const formatTriggerValue = (value) => isNumberProperty && !isNaN(Number(value))
        ? formatDollarValue(Number(value), selectedLocale, true, true)
        : value;
    const conditionLabel = isBetweenCondition
        ? t('gin_steps|between')
        : getConditionTypeLabel(firstCondition.condition_type, isDateProperty);
    const valueLabel = isBetweenCondition
        ? `${formatTriggerValue(firstValue)} ${t('gin_steps|and')} ${formatTriggerValue(secondValue)}`
        : formatTriggerValue(firstValue);
    const shouldRender = !(conditions.length === 1 &&
        (firstCondition === null || firstCondition === void 0 ? void 0 : firstCondition.condition_type) === ItemConditionType.Filled);
    if (!shouldRender)
        return null;
    const message = t('gin_steps|program_requirement_warning', {
        property_name: propertyLabel,
        condition: conditionLabel,
        value: valueLabel,
    });
    return (_jsx(GinStepPropertyConditionsContainer, { children: _jsx(Typography, { elementTheme: "overline", style: {
                fontWeight: 500,
                fontSize: 11,
                textTransform: 'uppercase',
                color: accentColor,
            }, children: formState === 'filling' || formState === 'viewing'
                ? message
                : `${conditionLabel} ${valueLabel}` }) }));
};
export default GinStepPropertyConditions;
